export default __webpack_public_path__ + "static/media/truck-icon-plus.d95cb13f.svg";